export default __webpack_public_path__ + "static/media/Ch2a.3443740d.gif";